import React from 'react';
import PropTypes from 'prop-types';

import { NumberFormat } from '@ecp/common/src/utils/utils';
import { FlexBox, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

const MemberSummary = ({ label, cnt, unit, title }) => {
  return (
    <>
      <Spacing top={20} />
      <FlexBoxSpaceBetween width={'100%'}>
        <TextBox font-size={title ? 24 : 16} font-weight={'700'} color={'#333333'}>
          {label}
        </TextBox>
        {!title && (
          <FlexBox align-items={'baseline'}>
            <TextBox font-size={30} font-weight={'700'} color={'#6C60FF'} line-height={'30px'}>
              {NumberFormat(cnt)}
            </TextBox>
            <Spacing left={10} />
            <TextBox font-size={18} font-weight={'700'} color={'#333333'} line-height={'18px'}>
              {unit}
            </TextBox>
          </FlexBox>
        )}
      </FlexBoxSpaceBetween>
    </>
  );
};

export default MemberSummary;

MemberSummary.propTypes = {
  label: PropTypes.string,
  cnt: PropTypes.number,
  unit: PropTypes.string,
  title: PropTypes.bool,
};

MemberSummary.defaultProps = {
  unit: '건',
  title: false,
};
